/**
 * Email API service for v0.8.0
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

import api from './api';

export interface SendVerificationData {
  message: string;
  expiresAt: string;
}

export interface VerifyEmailData {
  verified: boolean;
  message: string;
}

export interface NotificationPreferences {
  email: boolean;
  newWishMatch: boolean;
  adApproved: boolean;
  adRejected: boolean;
  weeklyDigest: boolean;
  marketing: boolean;
}

/**
 * Send email verification code
 */
export async function sendVerification(): Promise<{ success: boolean; error?: string }> {
  try {
    await api.post<SendVerificationData>('/api/members/me/send-verification', {});
    return { success: true };
  } catch (error: any) {
    return {
      success: false,
      error: error?.error?.message || 'Failed to send verification email',
    };
  }
}

/**
 * Verify email code (legacy method)
 */
export async function verifyEmail(email: string, code: string): Promise<{ success: boolean; data?: VerifyEmailData; error?: any }> {
  return api.post<VerifyEmailData>('/api/members/me/verify-email', { email, code });
}

/**
 * Verify email link with JWT token (v0.10.1)
 */
export async function verifyEmailLink(token: string): Promise<{ success: boolean; data?: VerifyEmailData; error?: any }> {
  return api.post<VerifyEmailData>('/api/members/me/verify-email-link', { token });
}

/**
 * Get notification preferences
 */
export async function getNotificationPreferences(): Promise<{ success: boolean; data?: NotificationPreferences; error?: any }> {
  return api.get<NotificationPreferences>('/api/members/me/notification-preferences');
}

/**
 * Update notification preferences
 */
export async function updateNotificationPreferences(
  prefs: Partial<NotificationPreferences>
): Promise<{ success: boolean; data?: NotificationPreferences; error?: any }> {
  return api.put<NotificationPreferences>('/api/members/me/notification-preferences', prefs);
}

/**
 * Unsubscribe from email notifications using token
 */
export async function unsubscribeEmail(token: string): Promise<{ success: boolean; error?: any }> {
  return api.post('/api/notifications/unsubscribe', { token });
}

/**
 * Get unsubscribe token for authenticated user
 */
export async function getUnsubscribeToken(): Promise<{ success: boolean; data?: { token: string; unsubscribeUrl: string }; error?: any }> {
  return api.get<{ token: string; unsubscribeUrl: string }>('/api/notifications/unsubscribe-token');
}
